import React from "react";
import Button from "components/UI/Button";
import ModalOverlay from "components/UI/ModalOverlay";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";

const style = {
  headerImage: {
    height: "80px",
    width: "80px",
    margin: "0px 10px"
  },
  textarea: {
    width: "90%",
    height: "271px",
    resize: "none",
    borderRadius: "45px",
    border: "none",
    padding: "25px",
    fontSize: "20px",
    backgroundColor: "#b5b5b6",
    margin: "20px"
  },
  modalBody: {
    width: "1000px"
  },
  button: {
    width: "230px",
    margin: "20px",
    fontSize: "20px"
  }
};

const header = (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <img
      style={style.headerImage}
      src={require("assets/images/mail-bg-white-nobg.png")}
      alt={"email"}
    />
    <p>Contact</p>
  </div>
);
class ContactModal extends React.Component {
  state = {
    message: ""
  };
  contactGym = () => {
    const gymid = this.props.gymid;
    const { message } = this.state;
    const access_token = localStorage.getItem("access_token");
    const toastId = toast("Sending...");
    axios
      .post(
        `${API_URL}/admin/gyms/contact/${gymid}`,
        { message },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        this.props.onClick();
      })
      .catch(err => {
        toast.dismiss(toastId);

        ERROR_HANDLE(err);
      });
  };
  render() {
    const { message } = this.state;
    return (
      <ModalOverlay
        header={header}
        bodyStyle={style.modalBody}
        close={this.props.onClick}
      >
        <textarea
          placeholder="Type Here...."
          style={style.textarea}
          value={message}
          onChange={e => {
            this.setState({ message: e.target.value });
          }}
        />
        <Button style={style.button} type="primary" onClick={this.contactGym}>
          Send
        </Button>
      </ModalOverlay>
    );
  }
}

export default ContactModal;
